import { render, staticRenderFns } from "./NoDataMessage.vue?vue&type=template&id=710039fe&scoped=true&"
import script from "./NoDataMessage.vue?vue&type=script&lang=js&"
export * from "./NoDataMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710039fe",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/common/NoDataMessage.vue
// module id = 1599
// module chunks = 0